const zhCN = {
  '上传': '上传',
  '请输入密码': '请输入密码'
}

export default zhCN